import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useVariables } from '../../../../providers/VariableProvider'
import DateTimePicker from './StyledPicker'

dayjs.extend(utc)

const useCreateCallback = (applyTo, setVariable) => useCallback((date) => {
  const parsed = dayjs.utc(date).format('YYYY-MM-DD')
  setVariable(applyTo, parsed)
}, [applyTo, setVariable])

function PipelineDatePicker ({
  startDateVariable,
  endDateVariable,
  format,
  disableFuture,
  disabled,
  style,
  className
}) {
  const {
    setVariable,
    getVariable
  } = useVariables()

  const setStartDate = useCreateCallback(startDateVariable, setVariable)
  const setEndDate = useCreateCallback(endDateVariable, setVariable)

  return (
    <>
      <DateTimePicker
        type='date'
        format={`[Start Date] ${format}`}
        disableFuture={disableFuture}
        onChange={setStartDate}
        extraStyles={style}
        className={className}
        value={getVariable(startDateVariable)}
        disabled={disabled}
      />
      <DateTimePicker
        type='date'
        format={`[End Date] ${format}`}
        disableFuture={disableFuture}
        onChange={setEndDate}
        extraStyles={style}
        className={className}
        value={getVariable(endDateVariable)}
      />
    </>
  )
}

PipelineDatePicker.propTypes = {
  startDateVariable: PropTypes.string,
  endDateVariable: PropTypes.string,
  format: PropTypes.string,
  disableFuture: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string
}

PipelineDatePicker.defaultProps = {
  format: 'MMMM DD, YYYY',
  disableFuture: true,
  disabled: false
}

export default PipelineDatePicker
